import dayjs from "dayjs";
import type { TransitDashboardApiResponse } from "../../hooks/react-query/linehaul/useTransitDashboard";
import type { RecentUpdate } from "../../pages/linehaul/tripsDashboard/inTransit/RecentUpdates/RecentUpdatesTile";
import type { TripDetails } from "../../pages/linehaul/tripsDashboard/inTransit/TransitDashboardTripDetailsRightPanel/TripInfoTabs/TripDetails";
import type { Stop } from "../../pages/linehaul/tripsDashboard/inTransit/TransitDashboardTripDetailsRightPanel/TripInfoTabs/TripDetails/Stops";

// Raw API response mock (what the API actually returns)
export const mockTransitDashboard: TransitDashboardApiResponse = {
  totalTripCount: 325,
  totalOnTimeCount: 36,
  totalLateCount: 112,
  totalRiskCount: 10,
  bills: 3460,
  weight: 3012084,
  tripSummaries: [
    {
      loadBoardId: 3104048,
      tripNumber: 10016841,
      carrier: {
        id: 95128,
        name: "COVENANT TRANSPORT INC",
        code: "L004",
        isActive: true,
      },
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: ["SEFL"],
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      drivers: [],
      employeeDrivers: [
        {
          id: 1001,
          loadBoardScheduleId: 3104048,
          name: "SMITH, JOHN",
          driverId: 5001,
          order: 1,
          ratePerMile: 0.5,
          refCode: "REF001",
        },
        {
          id: 1002,
          loadBoardScheduleId: 3104048,
          name: "JOHNSON, MIKE",
          driverId: 5002,
          order: 2,
          ratePerMile: 0.6,
          refCode: "REF002",
        },
        {
          id: 1003,
          loadBoardScheduleId: 3104048,
          name: "WILLIAMS, DAVID",
          driverId: 5003,
          order: 3,
          ratePerMile: 0.4,
          refCode: "REF003",
        },
      ],
      bookingNumber: "123456",
      trailerNumber: "123456",
      loadingDate: dayjs("2025-11-03T00:00:00"),
      pickupDate: dayjs("2025-11-03T23:25:00"),
      gateTime: dayjs("2025-11-04T16:30:00"),
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: ["CC", "UC"],
      sealNumber: "",
      cubage: null,
      status: "PLAN",
      driverCheckedIn: false,
      rolloverFee: null,
      isLoadAndHold: false,
      deadHeadOriginSicCode: "EWR",
      deadHeadDestinationSicCode: "ATB",
      etaTimestampUtc: dayjs("2025-11-07T18:00:00"),
      ataTimestampUtc: null,
      isStarred: false,
      ibCutTime: dayjs("2025-11-04T16:30:00"),
      latestUpdate: "1hr 38min",
      etaStatus: "Risk",
      lateBy: "4HR 43 MIN",
      hasNotes: false,
      serviceType: "1-way",
      opsCodeOrder: 1,
      loadPairScheduleId: 3113287,
      carrierRatePerMile: 0,
      tonu: 0,
      totalBills: 0,
      totalWeight: 0,
      ucBillsCount: 0,
      ccBillsCount: 0,
      apptBillsCount: 0,
      volBillsCount: 0,
      ltlBillsCount: 0,
      piecesCount: 0,
      palletsCount: 0,
      ucBillsTotalWeight: 0,
      ccBillsTotalWeight: 0,
      volBillsTotalWeight: 0,
      apptBillsTotalWeight: 0,
      ltlBillsTotalWeight: 0,
    },
    {
      loadBoardId: 3063160,
      tripNumber: 10016843,
      carrier: {
        id: 183026,
        name: "STARRY MANAGEMENT CO",
        code: "M271",
        isActive: true,
      },
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: [],
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      drivers: [],
      employeeDrivers: [
        {
          id: 2001,
          loadBoardScheduleId: 3063160,
          name: "BROWN, JAMES",
          driverId: 6001,
          order: 1,
          ratePerMile: 0.55,
          refCode: "REF004",
        },
        {
          id: 2002,
          loadBoardScheduleId: 3063160,
          name: "DAVIS, ROBERT",
          driverId: 6002,
          order: 2,
          ratePerMile: 0.65,
          refCode: "REF005",
        },
      ],
      bookingNumber: "123456",
      trailerNumber: "123456",
      loadingDate: dayjs("2025-11-03T00:00:00"),
      pickupDate: dayjs("2025-11-04T08:00:00"),
      gateTime: dayjs("2025-11-05T14:30:00"),
      closeDate: dayjs("2025-11-03T16:52:32"),
      bills: 0,
      weight: 0,
      tags: ["CC", "UC"],
      sealNumber: "123456",
      cubage: 28,
      // Status intentionally set to 'PLAN' for testing planned trip scenarios. See CodeQL rule guidance.
      status: "PLAN",
      driverCheckedIn: false,
      rolloverFee: null,
      isLoadAndHold: true,
      deadHeadOriginSicCode: "BOS",
      deadHeadDestinationSicCode: "ATB",
      etaTimestampUtc: dayjs("2025-11-08T20:00:00"),
      ataTimestampUtc: null,
      isStarred: false,
      ibCutTime: dayjs("2025-11-05T14:30:00"),
      latestUpdate: "1hr 38min",
      etaStatus: null,
      lateBy: null,
      hasNotes: false,
      serviceType: "Fleet",
      opsCodeOrder: 2,
      loadPairScheduleId: 3112799,
      carrierRatePerMile: 0,
      tonu: 0,
      totalBills: 0,
      totalWeight: 0,
      ucBillsCount: 0,
      ccBillsCount: 0,
      apptBillsCount: 0,
      volBillsCount: 0,
      ltlBillsCount: 0,
      piecesCount: 0,
      palletsCount: 0,
      ucBillsTotalWeight: 0,
      ccBillsTotalWeight: 0,
      volBillsTotalWeight: 0,
      apptBillsTotalWeight: 0,
      ltlBillsTotalWeight: 0,
    },
    {
      loadBoardId: 3062584,
      tripNumber: 3183808,
      carrier: {
        id: 95128,
        name: "COVENANT TRANSPORT INC",
        code: "L004",
        isActive: true,
      },
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: [],
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      drivers: [],
      employeeDrivers: [
        {
          id: 3001,
          loadBoardScheduleId: 3062584,
          name: "MILLER, WILLIAM",
          driverId: 7001,
          order: 1,
          ratePerMile: 0.5,
          refCode: "REF006",
        },
        {
          id: 3002,
          loadBoardScheduleId: 3062584,
          name: "WILSON, RICHARD",
          driverId: 7002,
          order: 2,
          ratePerMile: 0.6,
          refCode: "REF007",
        },
        {
          id: 3003,
          loadBoardScheduleId: 3062584,
          name: "MOORE, JOSEPH",
          driverId: 7003,
          order: 3,
          ratePerMile: 0.45,
          refCode: "REF008",
        },
        {
          id: 3004,
          loadBoardScheduleId: 3062584,
          name: "TAYLOR, THOMAS",
          driverId: 7004,
          order: 4,
          ratePerMile: 0.55,
          refCode: "REF009",
        },
      ],
      bookingNumber: "123456",
      trailerNumber: "123456",
      loadingDate: dayjs("2025-10-30T00:00:00"),
      pickupDate: dayjs("2025-10-31T04:00:00"),
      gateTime: dayjs("2025-11-01T11:00:00"),
      closeDate: dayjs("2025-10-31T02:47:53"),
      bills: 1,
      weight: 901,
      tags: ["UC"],
      sealNumber: "11509394",
      cubage: null,
      status: "ENRT",
      driverCheckedIn: false,
      rolloverFee: null,
      isLoadAndHold: false,
      deadHeadOriginSicCode: "NYC",
      deadHeadDestinationSicCode: "MIA",
      etaTimestampUtc: dayjs("2025-11-02T11:30:00"),
      ataTimestampUtc: dayjs("2025-11-02T11:20:03"),
      isStarred: false,
      ibCutTime: dayjs("2025-11-01T11:00:00"),
      latestUpdate: "1hr 38min",
      etaStatus: "Late",
      lateBy: "2HR 15 MIN",
      hasNotes: false,
      serviceType: "Dedicated",
      opsCodeOrder: 2,
      loadPairScheduleId: 3112372,
      carrierRatePerMile: 0,
      tonu: 0,
      totalBills: 37,
      totalWeight: 31507,
      ucBillsCount: 1,
      ccBillsCount: 0,
      apptBillsCount: 10,
      volBillsCount: 0,
      ltlBillsCount: 26,
      piecesCount: 0,
      palletsCount: 0,
      ucBillsTotalWeight: 901,
      ccBillsTotalWeight: 0,
      volBillsTotalWeight: 0,
      apptBillsTotalWeight: 16269,
      ltlBillsTotalWeight: 14337,
    },
    {
      loadBoardId: 3104088,
      tripNumber: 10016903,
      carrier: {
        id: 95128,
        name: "COVENANT TRANSPORT INC",
        code: "L004",
        isActive: true,
      },
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: [],
      destinationSic: {
        id: 111,
        code: "ONT",
        ownership: "C",
        lhRegionId: 6,
        timeZone: "America/Los_Angeles",
      },
      drivers: [],
      employeeDrivers: [
        {
          id: 4001,
          loadBoardScheduleId: 3104088,
          name: "ANDERSON, CHARLES",
          driverId: 8001,
          order: 1,
          ratePerMile: 0.5,
          refCode: "REF010",
        },
        {
          id: 4002,
          loadBoardScheduleId: 3104088,
          name: "JACKSON, DANIEL",
          driverId: 8002,
          order: 2,
          ratePerMile: 0.6,
          refCode: "REF011",
        },
      ],
      bookingNumber: "123456",
      trailerNumber: "123456",
      loadingDate: dayjs("2025-11-05T00:00:00"),
      pickupDate: dayjs("2025-11-05T15:00:00"),
      gateTime: null,
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: ["CC", "UC"],
      sealNumber: "",
      cubage: null,
      status: "PLAN",
      driverCheckedIn: false,
      rolloverFee: null,
      isLoadAndHold: false,
      deadHeadOriginSicCode: "CHI",
      deadHeadDestinationSicCode: "DFW",
      etaTimestampUtc: dayjs("2025-11-02T11:30:00"),
      ataTimestampUtc: dayjs("2025-11-02T11:30:00"),
      isStarred: false,
      ibCutTime: null,
      latestUpdate: "1hr 38min",
      etaStatus: "Risk",
      lateBy: "1HR 30 MIN",
      hasNotes: false,
      serviceType: "Dedicated",
      opsCodeOrder: 1,
      loadPairScheduleId: 3113295,
      carrierRatePerMile: 0,
      tonu: 0,
      totalBills: 0,
      totalWeight: 0,
      ucBillsCount: 0,
      ccBillsCount: 0,
      apptBillsCount: 0,
      volBillsCount: 0,
      ltlBillsCount: 0,
      piecesCount: 0,
      palletsCount: 0,
      ucBillsTotalWeight: 0,
      ccBillsTotalWeight: 0,
      volBillsTotalWeight: 0,
      apptBillsTotalWeight: 0,
      ltlBillsTotalWeight: 0,
    },
    {
      loadBoardId: 3063390,
      tripNumber: 10016933,
      carrier: {
        id: 92257,
        name: "HERRICK TRUCKING LLC",
        code: "M215",
        isActive: true,
      },
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: [],
      destinationSic: {
        id: 111,
        code: "ONT",
        ownership: "C",
        lhRegionId: 6,
        timeZone: "America/Los_Angeles",
      },
      drivers: [],
      employeeDrivers: [
        {
          id: 5001,
          loadBoardScheduleId: 3063390,
          name: "WHITE, MATTHEW",
          driverId: 9001,
          order: 1,
          ratePerMile: 0.5,
          refCode: "REF012",
        },
        {
          id: 5002,
          loadBoardScheduleId: 3063390,
          name: "HARRIS, ANTHONY",
          driverId: 9002,
          order: 2,
          ratePerMile: 0.6,
          refCode: "REF013",
        },
        {
          id: 5003,
          loadBoardScheduleId: 3063390,
          name: "MARTIN, MARK",
          driverId: 9003,
          order: 3,
          ratePerMile: 0.45,
          refCode: "REF014",
        },
      ],
      bookingNumber: "123456",
      trailerNumber: "123456",
      loadingDate: dayjs("2025-11-05T00:00:00"),
      pickupDate: dayjs("2025-11-05T23:00:00"),
      gateTime: dayjs("2025-11-08T11:00:00"),
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: ["CC", "UC"],
      sealNumber: "",
      cubage: null,
      status: "PLAN",
      driverCheckedIn: false,
      rolloverFee: null,
      isLoadAndHold: false,
      deadHeadOriginSicCode: "POR",
      deadHeadDestinationSicCode: "SLC",
      etaTimestampUtc: dayjs("2025-11-02T11:30:00"),
      ataTimestampUtc: null,
      isStarred: false,
      ibCutTime: dayjs("2025-11-08T11:00:00"),
      latestUpdate: "1hr 38min",
      etaStatus: "OnTime",
      lateBy: null,
      hasNotes: false,
      serviceType: "Fleet",
      opsCodeOrder: 2,
      loadPairScheduleId: 3112975,
      carrierRatePerMile: 0,
      tonu: 0,
      totalBills: 0,
      totalWeight: 0,
      ucBillsCount: 0,
      ccBillsCount: 0,
      apptBillsCount: 0,
      volBillsCount: 0,
      ltlBillsCount: 0,
      piecesCount: 0,
      palletsCount: 0,
      ucBillsTotalWeight: 0,
      ccBillsTotalWeight: 0,
      volBillsTotalWeight: 0,
      apptBillsTotalWeight: 0,
      ltlBillsTotalWeight: 0,
    },
    {
      loadBoardId: 3104048,
      tripNumber: 10016848,
      carrier: {
        id: 95128,
        name: "COVENANT TRANSPORT INC",
        code: "L004",
        isActive: true,
      },
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: [],
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      drivers: [],
      employeeDrivers: [
        {
          id: 6001,
          loadBoardScheduleId: 3104048,
          name: "THOMPSON, DONALD",
          driverId: 10001,
          order: 1,
          ratePerMile: 0.5,
          refCode: "REF015",
        },
        {
          id: 6002,
          loadBoardScheduleId: 3104048,
          name: "GARCIA, STEVEN",
          driverId: 10002,
          order: 2,
          ratePerMile: 0.6,
          refCode: "REF016",
        },
      ],
      bookingNumber: "123456",
      trailerNumber: "123456",
      loadingDate: dayjs("2025-11-03T00:00:00"),
      pickupDate: dayjs("2025-11-03T23:25:00"),
      gateTime: dayjs("2025-11-04T16:30:00"),
      closeDate: null,
      bills: 0,
      weight: 0,
      tags: ["CC", "UC"],
      sealNumber: "",
      cubage: null,
      status: "PLAN",
      driverCheckedIn: false,
      rolloverFee: null,
      isLoadAndHold: false,
      deadHeadOriginSicCode: "DEN",
      deadHeadDestinationSicCode: "PHX",
      etaTimestampUtc: dayjs("2025-11-07T18:00:00"),
      ataTimestampUtc: null,
      isStarred: false,
      ibCutTime: dayjs("2025-11-04T16:30:00"),
      latestUpdate: "1hr 38min",
      etaStatus: null,
      lateBy: null,
      hasNotes: false,
      serviceType: "1-way",
      opsCodeOrder: 1,
      loadPairScheduleId: 3113287,
      carrierRatePerMile: 0,
      tonu: 0,
      totalBills: 0,
      totalWeight: 0,
      ucBillsCount: 0,
      ccBillsCount: 0,
      apptBillsCount: 0,
      volBillsCount: 0,
      ltlBillsCount: 0,
      piecesCount: 0,
      palletsCount: 0,
      ucBillsTotalWeight: 0,
      ccBillsTotalWeight: 0,
      volBillsTotalWeight: 0,
      apptBillsTotalWeight: 0,
      ltlBillsTotalWeight: 0,
    },
    {
      loadBoardId: 3063160,
      tripNumber: 10016849,
      carrier: {
        id: 183026,
        name: "STARRY MANAGEMENT CO",
        code: "M271",
        isActive: true,
      },
      originSic: {
        id: 103,
        code: "ATB",
        ownership: "V",
        lhRegionId: 3,
        timeZone: "America/New_York",
      },
      stops: [],
      destinationSic: {
        id: 2,
        code: "LAX",
        ownership: "C",
        lhRegionId: 5,
        timeZone: "America/Los_Angeles",
      },
      drivers: [],
      employeeDrivers: [
        {
          id: 7001,
          loadBoardScheduleId: 3063160,
          name: "MARTINEZ, PAUL",
          driverId: 11001,
          order: 1,
          ratePerMile: 0.5,
          refCode: "REF017",
        },
        {
          id: 7002,
          loadBoardScheduleId: 3063160,
          name: "ROBINSON, ANDREW",
          driverId: 11002,
          order: 2,
          ratePerMile: 0.6,
          refCode: "REF018",
        },
        {
          id: 7003,
          loadBoardScheduleId: 3063160,
          name: "CLARK, JOSHUA",
          driverId: 11003,
          order: 3,
          ratePerMile: 0.4,
          refCode: "REF019",
        },
      ],
      bookingNumber: "123456",
      trailerNumber: "123456",
      loadingDate: dayjs("2025-11-03T00:00:00"),
      pickupDate: dayjs("2025-11-04T08:00:00"),
      gateTime: dayjs("2025-11-05T14:30:00"),
      closeDate: dayjs("2025-11-03T16:52:32"),
      bills: 0,
      weight: 0,
      tags: ["CC", "UC"],
      sealNumber: "123456",
      cubage: 28,
      status: "PLAN",
      driverCheckedIn: false,
      rolloverFee: null,
      isLoadAndHold: true,
      deadHeadOriginSicCode: "",
      deadHeadDestinationSicCode: "",
      etaTimestampUtc: dayjs("2025-11-08T20:00:00"),
      ataTimestampUtc: null,
      isStarred: false,
      ibCutTime: dayjs("2025-11-05T14:30:00"),
      latestUpdate: "1hr 38min",
      etaStatus: null,
      lateBy: null,
      hasNotes: false,
      serviceType: "Fleet",
      opsCodeOrder: 2,
      loadPairScheduleId: 3112799,
      carrierRatePerMile: 0,
      tonu: 0,
      totalBills: 0,
      totalWeight: 0,
      ucBillsCount: 0,
      ccBillsCount: 0,
      apptBillsCount: 0,
      volBillsCount: 0,
      ltlBillsCount: 0,
      piecesCount: 0,
      palletsCount: 0,
      ucBillsTotalWeight: 0,
      ccBillsTotalWeight: 0,
      volBillsTotalWeight: 0,
      apptBillsTotalWeight: 0,
      ltlBillsTotalWeight: 0,
    },
  ],
  nextCursor: "10016933",
  previousCursor: "10016841",
  hasMore: true,
  hasPrevious: false,
} as const satisfies TransitDashboardApiResponse;

/**
 * Mock data for Recent Updates feature in Transit Dashboard
 */
export const mockRecentUpdates = {
  default: [
    {
      tripNumber: 294039,
      status: "ENRT",
      originSic: "ATL",
      stopSic: "CHT",
      destinationSic: "SFO",
      updatedAt: "1m ago",
      carrier: "M027 - Jackson Transport",
      bookingNumber: "123456",
      trailerNumber: "123456",
      eta: dayjs("2024-06-23T15:00:00"),
      timeStatus: "LATE",
      isFavorite: true,
    },
    {
      tripNumber: 346383,
      status: "ENRT",
      originSic: "ATL",
      stopSic: "CHT",
      destinationSic: "SFO",
      updatedAt: "1m ago",
      carrier: "M027 - Jackson Transport",
      bookingNumber: "123456",
      trailerNumber: "123456",
      eta: dayjs("2024-06-23T15:00:00"),
      timeStatus: "ON TIME",
      isFavorite: false,
    },
    {
      tripNumber: 58363,
      status: "ENRT",
      originSic: "ATL",
      stopSic: "CHT",
      destinationSic: "SFO",
      updatedAt: "1m ago",
      carrier: "M027 - Jackson Transport",
      bookingNumber: "123456",
      trailerNumber: "123456",
      eta: dayjs("2024-06-23T15:00:00"),
      timeStatus: "ON TIME",
      isFavorite: false,
    },
    {
      tripNumber: 103734,
      status: "ENRT",
      originSic: "ATL",
      stopSic: "CHT",
      destinationSic: "SFO",
      updatedAt: "2m ago",
      carrier: "M027 - Jackson Transport",
      bookingNumber: "123456",
      trailerNumber: "123456",
      eta: dayjs("2024-06-23T15:00:00"),
      timeStatus: "AT RISK",
      isFavorite: true,
    },
    {
      tripNumber: 404840,
      status: "ENRT",
      originSic: "ATL",
      stopSic: "CHT",
      destinationSic: "SFO",
      updatedAt: "5m ago",
      carrier: "M027 - Jackson Transport",
      bookingNumber: "123456",
      trailerNumber: "123456",
      eta: dayjs("2024-06-23T15:00:00"),
      timeStatus: "LATE",
      isFavorite: false,
    },
    {
      tripNumber: 298471,
      status: "ENRT",
      originSic: "ATL",
      stopSic: "CHT",
      destinationSic: "MIA",
      updatedAt: "15m ago",
      carrier: "M015 - Swift Logistics",
      bookingNumber: "789012",
      trailerNumber: "789012",
      eta: dayjs("2024-06-24T18:00:00"),
      timeStatus: "ON TIME",
      isFavorite: true,
    },
    {
      tripNumber: 187652,
      status: "ENRT",
      originSic: "DFW",
      destinationSic: "HOU",
      updatedAt: "30m ago",
      carrier: "M042 - Rapid Freight",
      bookingNumber: "345678",
      trailerNumber: "345678",
      eta: dayjs("2024-06-25T21:00:00"),
      timeStatus: "AT RISK",
      isFavorite: false,
    },
    {
      tripNumber: 512934,
      status: "ENRT",
      originSic: "LAX",
      stopSic: "PHX",
      destinationSic: "DEN",
      updatedAt: "1h ago",
      carrier: "M028 - West Coast Express",
      bookingNumber: "901234",
      trailerNumber: "901234",
      eta: dayjs("2024-06-25T12:00:00"),
      timeStatus: "ON TIME",
      isFavorite: false,
    },
    {
      tripNumber: 512935,
      status: "ENRT",
      originSic: "LAX",
      stopSic: "PHX",
      destinationSic: "DEN",
      updatedAt: "1h ago",
      carrier: "M028 - West Coast Express",
      bookingNumber: "901234",
      trailerNumber: "901234",
      eta: dayjs("2024-06-25T12:00:00"),
      timeStatus: "ON TIME",
      isFavorite: false,
    },
    {
      tripNumber: 512936,
      status: "ENRT",
      originSic: "LAX",
      stopSic: "PHX",
      destinationSic: "DEN",
      updatedAt: "1h ago",
      carrier: "M028 - West Coast Express",
      bookingNumber: "901234",
      trailerNumber: "901234",
      eta: dayjs("2024-06-25T12:00:00"),
      timeStatus: "ON TIME",
      isFavorite: false,
    },
  ],
} as const satisfies Record<string, RecentUpdate[]>;

/**
 * Mock data for Transit Dashboard Shipments
 */
export const mockTransitDashboardShipments = {
  default: {
    totalcount: 20,
    shipments: [
      {
        shipmentId: 135392846,
        proNumber: "P9370245",
        tagsValue: null,
        tags: ["CC"],
        serviceDue: dayjs("2025-11-20T20:00:00"),
        pickupDate: dayjs("2025-11-17T17:00:00"),
        tripNumber: 10017305,
        shipperName: "FORUM SOLUTIONS",
        shipperZipCode: "30575",
        consigneeName: "ARMINAK SOLUTIONS LLC",
        consigneeZipCode: "92880",
        weight: 558,
        pallets: 1,
        pieces: 2,
        revenue: 33.0,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135398473,
        proNumber: "180363327",
        tagsValue: null,
        tags: ["UC"],
        serviceDue: dayjs("2025-11-18T23:00:00"),
        pickupDate: dayjs("2025-11-14T21:00:00"),
        tripNumber: 10017305,
        shipperName: "GERARD DANIELS",
        shipperZipCode: "38310",
        consigneeName: "PENTAIR POOL PRODUCTS",
        consigneeZipCode: "93021",
        weight: 447,
        pallets: 1,
        pieces: 0,
        revenue: 377.68,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "LAX",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135404921,
        proNumber: "P9373564",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-18T22:00:00"),
        pickupDate: dayjs("2025-11-14T19:00:00"),
        tripNumber: 10017305,
        shipperName: "ART & FRAME DIRECT",
        shipperZipCode: "32837",
        consigneeName: "MONIQUE KAGELE",
        consigneeZipCode: "92672",
        weight: 136,
        pallets: 1,
        pieces: 0,
        revenue: 394.09,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135405099,
        proNumber: "P9373614",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-18T16:00:00"),
        pickupDate: dayjs("2025-11-14T13:00:00"),
        tripNumber: 10017305,
        shipperName: "WAREHOUSE SOLUTIONS",
        shipperZipCode: "30720",
        consigneeName: "PRO EQUITY MANAGEMENT",
        consigneeZipCode: "95825",
        weight: 455,
        pallets: 1,
        pieces: 13,
        revenue: 148.0,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "SFO",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135406356,
        proNumber: "180363988",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-20T08:00:00"),
        pickupDate: dayjs("2025-11-14T06:00:00"),
        tripNumber: 10017305,
        shipperName: "RANDA ACCESSORIES",
        shipperZipCode: "70087",
        consigneeName: "SEINO @ CASUAL TEXTILES INC",
        consigneeZipCode: "90504",
        weight: 2083,
        pallets: 4,
        pieces: 0,
        revenue: 1030.02,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "LAX",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135410519,
        proNumber: "P9375418",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-18T23:00:00"),
        pickupDate: dayjs("2025-11-17T20:00:00"),
        tripNumber: 10017305,
        shipperName: "DACKOR",
        shipperZipCode: "34787",
        consigneeName: "CORONA MILLWORKS",
        consigneeZipCode: "91710",
        weight: 163,
        pallets: 1,
        pieces: 0,
        revenue: 165.42,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "ONT",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
      {
        shipmentId: 135414524,
        proNumber: "P9376497",
        tagsValue: null,
        tags: ["APTR"],
        serviceDue: dayjs("2025-11-21T17:00:00"),
        pickupDate: dayjs("2025-11-17T15:00:00"),
        tripNumber: 10017305,
        shipperName: "WESLEY DARNELL",
        shipperZipCode: "37043",
        consigneeName: "SPECIALIZED GERMAN RECYCLING",
        consigneeZipCode: "95742",
        weight: 438,
        pallets: 1,
        pieces: 1,
        revenue: 343.98,
        originSicCode: "ATB-SEFL",
        destinationSicCode: "SFO",
        currentSicCode: "ATB-SEFL",
        originSic: null,
        destinationSic: null,
        currentSic: null,
        status: "LDDK",
      },
    ],
  },
};

/**
 * Mock data for Trip Details feature in Transit Dashboard
 */
export const mockTripDetails = {
  default: {
    sealNumber: "123456",
    cubageEstimate: 98,
    scacCode: "",
    closeDate: dayjs("2024-12-02T15:00:00"),
    departureTime: dayjs("2024-12-03T17:30:00"),
    startLoadEta: dayjs("2024-12-02T10:00:00"),
    gateCutDate: dayjs("2024-12-02T15:00:00"),
    mileage: 2600,
    ratePerMile: 1.5,
    accessorials: [
      { code: "DETEN", name: "Detention", cost: 50, isEditable: true },
      { code: "ROLLOVER", name: "Rollover", cost: 250, isEditable: true },
      { code: "STOPFEE", name: "Added Stop Fee", cost: 75, isEditable: true },
      {
        code: "LHOOFuelCg",
        name: "CA Supplementary Fuel",
        cost: 325,
        isEditable: false,
        qty: 2600,
        rate: 0.125,
      },
      { code: "TONU", name: "TONU", cost: 100, isEditable: true },
      {
        code: "LHDeadhead",
        name: "Deadhead",
        cost: 243.75,
        isEditable: false,
        qty: 150,
        rate: 1.625,
      },
    ],
    scheduleId: 3104449,
    loadPairScheduleId: 3114779,
    bookingNumber: "1234567",
    bookingStatus: "Confirmed",
    tripStatus: "LDDK",
    originSicCode: "ATB",
    destinationSicCode: "ONT",
    loadingDate: dayjs("2024-12-02T00:00:00"),
    pickupDate: dayjs("2024-12-02T10:00:00"),
    serviceType: "1-way",
    carrierName: "Testing Carrier",
    carrierCode: "TEST",
    tripNumber: 10017491,
    trailerNumber: "428017",
    deadheads: [{ originSicCode: "ONT", destinationSicCode: "LAX" }],
    stops: ["CHT", "DAL", "ONT", "LAX"],
    tripPriority: 1,
    totalRevenue: 826,
    totalCost: 750,
    netLinehaul: 76,
    isPublished: true,
    isCancelled: false,
    loadType: "Start",
    hasLoadPair: false,
    tonu: 0,
    employeeDrivers: [
      {
        id: 2354,
        loadBoardScheduleId: 3104449,
        name: "DIAZ, MARIO ANTONIO",
        driverId: 9770,
        order: 1,
        ratePerMile: 0.5,
      },
      {
        id: 2355,
        loadBoardScheduleId: 3104449,
        name: "ATWAL, GURTEJ SINGH",
        driverId: 9755,
        order: 2,
        ratePerMile: 0.6,
      },
      {
        id: 2356,
        loadBoardScheduleId: 3104449,
        name: "HEREDIA, EDGAR",
        driverId: 10255,
        order: 3,
        ratePerMile: 0.4,
      },
    ],
    carrierRatePerMile: 0,
    originSic: {
      id: 1,
      code: "ATB-SEFL",
      lhRegionId: 1,
      ownership: "C",
      timeZone: "America/New_York",
    },
    destinationSic: {
      id: 2,
      code: "ONT",
      lhRegionId: 4,
      ownership: "C",
      timeZone: "America/Los_Angeles",
    },
    totalBills: 24,
    totalWeight: 48000,
    ucBillsCount: 2,
    ccBillsCount: 2,
    apptBillsCount: 0,
    volBillsCount: 0,
    ltlBillsCount: 4,
    loadedBills: 4,
    loadedWeight: 5799,
    piecesCount: 2,
    palletsCount: 6,
    ucBillsTotalWeight: 900,
    ccBillsTotalWeight: 800,
    volBillsTotalWeight: 0,
    apptBillsTotalWeight: 0,
    ltlBillsTotalWeight: 5799,
    rolloverFee: 0,
    isLoadAndHold: true,
    latestUpdate: "0hr 38 min",
    groupedShipmentsByStop: [
      {
        title: "Stop 1",
        tagCode: "CHT",
        isDestination: false,
        data: {
          ata: dayjs("2024-12-02T17:30:00"),
          departureTime: dayjs("2024-12-02T15:00:00"),
          ibCutTime: dayjs("2024-12-02T10:00:00"),
          transitStatus: "LATE",
        },
      },
      {
        title: "Stop 2",
        tagCode: "DAL",
        isDestination: false,
        data: {
          eta: dayjs("2024-12-02T17:30:00"),
          departureTime: dayjs("2024-12-02T15:00:00"),
          ibCutTime: dayjs("2024-12-02T10:00:00"),
          transitStatus: "LATE",
        },
      },
      {
        title: "Final Destination",
        tagCode: "ONT",
        isDestination: true,
        data: {
          eta: dayjs("2024-12-02T17:30:00"),
          departureTime: dayjs("2024-12-02T15:00:00"),
          ibCutTime: dayjs("2024-12-02T10:00:00"),
          transitStatus: "LATE",
        },
      },
    ] as Stop[],
    shipments: [],
    driverCheckInDetails: [],
  },
} as const satisfies Record<string, TripDetails>;

/**
 * Mock data for Trip Documents feature in Transit Dashboard
 */
export const mockTripDocuments = [
  {
    id: 1,
    documentType: "Invoice",
    documentName: "INV-2024-10017491.pdf",
    // The toDate() will be removed after the API integration for ticket LH-2513 has been completed.
    uploadedAt: dayjs("2024-12-02T10:00:00").toDate(),
    uploadedBy: "John Smith",
  },
  {
    id: 2,
    documentType: "Carrier bill of lading",
    documentName: "BOL-TEST-1234567.pdf",
    // The toDate() will be removed after the API integration for ticket LH-2513 has been completed.
    uploadedAt: dayjs("2024-12-02T10:00:00").toDate(),
    uploadedBy: "Sarah Johnson",
  },
];
